import type { TableData } from '@app/types/table'
import type { ResponseDto } from '@app/api/dtos'
import type { RegistryArchiveListDataSource } from '../types'
import type { ProductDto } from '@app/api/routes/monitoringLists/dtos'

export const adaptRegistryArchiveListTableData = (
  productResponse: ResponseDto<ProductDto>
): TableData<RegistryArchiveListDataSource> => {
  const { count, results: products } = productResponse

  const dataSource: RegistryArchiveListDataSource[] = products.map(dto => ({
    key: dto.id,
    id: dto.product?.id ?? null,
    trend: dto.product?.subcategory?.purchasingGroup?.trend?.name ?? null,
    trendId: dto.product?.subcategory?.purchasingGroup?.trend?.id ?? null,
    purchasingGroup: dto.product?.subcategory?.purchasingGroup?.name ?? null,
    purchasingGroupId: dto.product?.subcategory?.purchasingGroup?.id ?? null,
    commodityGroup: dto.product?.subcategory.category.commodityGroup.name ?? null,
    commodityGroupId: dto.product?.subcategory.category.commodityGroup.id ?? null,
    category: dto.product?.subcategory?.category?.name ?? null,
    categoryId: dto.product?.subcategory?.category?.id ?? null,
    subcategory: dto.product?.subcategory?.name ?? null,
    subcategoryId: dto.product?.subcategory?.id ?? null,
    isEPP: dto.isEPP ?? null,
    isCHTM: dto.product?.isCHTM ?? null,
    code: dto.product?.code ?? null,
    name: dto.product?.name ?? null,
    howToMonitor: dto.howToMonitor ?? null,
    isRecalculation: dto.isRecalculation ?? null,
    isShortKvi: dto.isShortKvi ?? null,
    isTop1: dto.isTop1 ?? null,
    isInfo: dto.isInfo ?? null,
    monitoringSubtypesCount: dto.monitoringSubtypes?.length ?? null,
    status: dto.status ?? null,
    subtypes: dto.monitoringSubtypes ?? null
  }))

  return { count, dataSource }
}
